import BannerArea from "../home/banner";
import "./hero-area.css";

const HeroArea = () => {
  return (
    <>
      <div className="hero-area">
        <BannerArea></BannerArea>
      </div>
    </>
  );
};

export default HeroArea;
